import { IOrderDsd } from "../../../types/order.types";
import { transformQuantity } from "../../../utils/formatNumber";
import { formatDateTime } from "../../../utils/date-time-format";
import { TableColumn } from "../../Table/CommonTable.types";
import { commonProps } from "../WarehouseOrderHistory/utils";

export const orderHistoryColumns: TableColumn<IOrderDsd>[] = [
  {
    id: "orderNumber",
    label: "Invoice # / Order #",
    value: (row) => row.orderNumber || "-",
    ...commonProps<IOrderDsd>(),
    align: "center",
  },
  {
    id: "orderQuantity",
    label: "Ordered Units",
    value: (row) => transformQuantity(row.orderQuantity || 0) || "",
    ...commonProps<IOrderDsd>(),
    align: "right",
    type: "number",
  },
  {
    id: "statusTypeCd",
    label: "STATUS",
    value: (row) => {
      if (row.isLast) {
        return "";
      }
      return row.statusTypeCd || "-";
    },
    ...commonProps<IOrderDsd>(),
    align: "center",
  },
  {
    id: "scheduledDeliveryDate",
    label: "Estimated Arrival Date",
    value: (row) => {
      if (row.isLast) {
        return "";
      }
      return row.scheduledDeliveryDate
        ? formatDateTime(row.scheduledDeliveryDate.split("T")[0]).date
        : "-";
    },
    ...commonProps<IOrderDsd>(),
    align: "center",
    type: "date",
  },
];
